// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/connection/v1/connection_api.proto (package gdx.gateway.web.connection.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { NotificationCategory } from "./notification_pb.js";
import { SearchProfile } from "../../profile/v1/search_pb.js";
import { ProfilePhoto } from "../../profile/v1/profile_pb.js";

/**
 * @generated from message gdx.gateway.web.connection.v1.GetNotificationProfileRequest
 */
export class GetNotificationProfileRequest extends Message<GetNotificationProfileRequest> {
  /**
   * @generated from field: gdx.gateway.web.connection.v1.NotificationCategory category = 1;
   */
  category = NotificationCategory.INVALID;

  constructor(data?: PartialMessage<GetNotificationProfileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.connection.v1.GetNotificationProfileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "category", kind: "enum", T: proto3.getEnumType(NotificationCategory) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNotificationProfileRequest {
    return new GetNotificationProfileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNotificationProfileRequest {
    return new GetNotificationProfileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNotificationProfileRequest {
    return new GetNotificationProfileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetNotificationProfileRequest | PlainMessage<GetNotificationProfileRequest> | undefined, b: GetNotificationProfileRequest | PlainMessage<GetNotificationProfileRequest> | undefined): boolean {
    return proto3.util.equals(GetNotificationProfileRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.connection.v1.GetNotificationProfileResponse
 */
export class GetNotificationProfileResponse extends Message<GetNotificationProfileResponse> {
  /**
   * @generated from field: gdx.gateway.web.profile.v1.SearchProfile profile = 1;
   */
  profile?: SearchProfile;

  constructor(data?: PartialMessage<GetNotificationProfileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.connection.v1.GetNotificationProfileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile", kind: "message", T: SearchProfile },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNotificationProfileResponse {
    return new GetNotificationProfileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNotificationProfileResponse {
    return new GetNotificationProfileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNotificationProfileResponse {
    return new GetNotificationProfileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetNotificationProfileResponse | PlainMessage<GetNotificationProfileResponse> | undefined, b: GetNotificationProfileResponse | PlainMessage<GetNotificationProfileResponse> | undefined): boolean {
    return proto3.util.equals(GetNotificationProfileResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.connection.v1.LikeEngagementProfilesRequest
 */
export class LikeEngagementProfilesRequest extends Message<LikeEngagementProfilesRequest> {
  /**
   * @generated from field: repeated gdx.gateway.web.connection.v1.LikeEngagementProfilesRequest.EngagementLike likes = 3;
   */
  likes: LikeEngagementProfilesRequest_EngagementLike[] = [];

  constructor(data?: PartialMessage<LikeEngagementProfilesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.connection.v1.LikeEngagementProfilesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 3, name: "likes", kind: "message", T: LikeEngagementProfilesRequest_EngagementLike, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LikeEngagementProfilesRequest {
    return new LikeEngagementProfilesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LikeEngagementProfilesRequest {
    return new LikeEngagementProfilesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LikeEngagementProfilesRequest {
    return new LikeEngagementProfilesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: LikeEngagementProfilesRequest | PlainMessage<LikeEngagementProfilesRequest> | undefined, b: LikeEngagementProfilesRequest | PlainMessage<LikeEngagementProfilesRequest> | undefined): boolean {
    return proto3.util.equals(LikeEngagementProfilesRequest, a, b);
  }
}

/**
 * Engagement profile like data.
 *
 * @generated from message gdx.gateway.web.connection.v1.LikeEngagementProfilesRequest.EngagementLike
 */
export class LikeEngagementProfilesRequest_EngagementLike extends Message<LikeEngagementProfilesRequest_EngagementLike> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: bool is_liked = 2;
   */
  isLiked = false;

  constructor(data?: PartialMessage<LikeEngagementProfilesRequest_EngagementLike>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.connection.v1.LikeEngagementProfilesRequest.EngagementLike";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_liked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LikeEngagementProfilesRequest_EngagementLike {
    return new LikeEngagementProfilesRequest_EngagementLike().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LikeEngagementProfilesRequest_EngagementLike {
    return new LikeEngagementProfilesRequest_EngagementLike().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LikeEngagementProfilesRequest_EngagementLike {
    return new LikeEngagementProfilesRequest_EngagementLike().fromJsonString(jsonString, options);
  }

  static equals(a: LikeEngagementProfilesRequest_EngagementLike | PlainMessage<LikeEngagementProfilesRequest_EngagementLike> | undefined, b: LikeEngagementProfilesRequest_EngagementLike | PlainMessage<LikeEngagementProfilesRequest_EngagementLike> | undefined): boolean {
    return proto3.util.equals(LikeEngagementProfilesRequest_EngagementLike, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.connection.v1.LikeEngagementProfilesResponse
 */
export class LikeEngagementProfilesResponse extends Message<LikeEngagementProfilesResponse> {
  constructor(data?: PartialMessage<LikeEngagementProfilesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.connection.v1.LikeEngagementProfilesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LikeEngagementProfilesResponse {
    return new LikeEngagementProfilesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LikeEngagementProfilesResponse {
    return new LikeEngagementProfilesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LikeEngagementProfilesResponse {
    return new LikeEngagementProfilesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: LikeEngagementProfilesResponse | PlainMessage<LikeEngagementProfilesResponse> | undefined, b: LikeEngagementProfilesResponse | PlainMessage<LikeEngagementProfilesResponse> | undefined): boolean {
    return proto3.util.equals(LikeEngagementProfilesResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.connection.v1.GetEngagementProfilesRequest
 */
export class GetEngagementProfilesRequest extends Message<GetEngagementProfilesRequest> {
  /**
   * @generated from field: uint32 limit = 1;
   */
  limit = 0;

  constructor(data?: PartialMessage<GetEngagementProfilesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.connection.v1.GetEngagementProfilesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEngagementProfilesRequest {
    return new GetEngagementProfilesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEngagementProfilesRequest {
    return new GetEngagementProfilesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEngagementProfilesRequest {
    return new GetEngagementProfilesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetEngagementProfilesRequest | PlainMessage<GetEngagementProfilesRequest> | undefined, b: GetEngagementProfilesRequest | PlainMessage<GetEngagementProfilesRequest> | undefined): boolean {
    return proto3.util.equals(GetEngagementProfilesRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.connection.v1.GetEngagementProfilesResponse
 */
export class GetEngagementProfilesResponse extends Message<GetEngagementProfilesResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.connection.v1.GetEngagementProfilesResponse.EngagementProfile profiles = 3;
   */
  profiles: GetEngagementProfilesResponse_EngagementProfile[] = [];

  constructor(data?: PartialMessage<GetEngagementProfilesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.connection.v1.GetEngagementProfilesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 3, name: "profiles", kind: "message", T: GetEngagementProfilesResponse_EngagementProfile, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEngagementProfilesResponse {
    return new GetEngagementProfilesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEngagementProfilesResponse {
    return new GetEngagementProfilesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEngagementProfilesResponse {
    return new GetEngagementProfilesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetEngagementProfilesResponse | PlainMessage<GetEngagementProfilesResponse> | undefined, b: GetEngagementProfilesResponse | PlainMessage<GetEngagementProfilesResponse> | undefined): boolean {
    return proto3.util.equals(GetEngagementProfilesResponse, a, b);
  }
}

/**
 * Engagement profile entry, is not reusable, encapsulated in here.
 *
 * @generated from message gdx.gateway.web.connection.v1.GetEngagementProfilesResponse.EngagementProfile
 */
export class GetEngagementProfilesResponse_EngagementProfile extends Message<GetEngagementProfilesResponse_EngagementProfile> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 2;
   */
  avatar?: ProfilePhoto;

  constructor(data?: PartialMessage<GetEngagementProfilesResponse_EngagementProfile>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.connection.v1.GetEngagementProfilesResponse.EngagementProfile";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "avatar", kind: "message", T: ProfilePhoto },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetEngagementProfilesResponse_EngagementProfile {
    return new GetEngagementProfilesResponse_EngagementProfile().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetEngagementProfilesResponse_EngagementProfile {
    return new GetEngagementProfilesResponse_EngagementProfile().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetEngagementProfilesResponse_EngagementProfile {
    return new GetEngagementProfilesResponse_EngagementProfile().fromJsonString(jsonString, options);
  }

  static equals(a: GetEngagementProfilesResponse_EngagementProfile | PlainMessage<GetEngagementProfilesResponse_EngagementProfile> | undefined, b: GetEngagementProfilesResponse_EngagementProfile | PlainMessage<GetEngagementProfilesResponse_EngagementProfile> | undefined): boolean {
    return proto3.util.equals(GetEngagementProfilesResponse_EngagementProfile, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.connection.v1.GetOffboardingProfilesRequest
 */
export class GetOffboardingProfilesRequest extends Message<GetOffboardingProfilesRequest> {
  /**
   * @generated from field: uint32 limit = 1;
   */
  limit = 0;

  constructor(data?: PartialMessage<GetOffboardingProfilesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.connection.v1.GetOffboardingProfilesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOffboardingProfilesRequest {
    return new GetOffboardingProfilesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOffboardingProfilesRequest {
    return new GetOffboardingProfilesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOffboardingProfilesRequest {
    return new GetOffboardingProfilesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOffboardingProfilesRequest | PlainMessage<GetOffboardingProfilesRequest> | undefined, b: GetOffboardingProfilesRequest | PlainMessage<GetOffboardingProfilesRequest> | undefined): boolean {
    return proto3.util.equals(GetOffboardingProfilesRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.connection.v1.GetOffboardingProfilesResponse
 */
export class GetOffboardingProfilesResponse extends Message<GetOffboardingProfilesResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.profile.v1.SearchProfile profiles = 3;
   */
  profiles: SearchProfile[] = [];

  constructor(data?: PartialMessage<GetOffboardingProfilesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.connection.v1.GetOffboardingProfilesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 3, name: "profiles", kind: "message", T: SearchProfile, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOffboardingProfilesResponse {
    return new GetOffboardingProfilesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOffboardingProfilesResponse {
    return new GetOffboardingProfilesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOffboardingProfilesResponse {
    return new GetOffboardingProfilesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOffboardingProfilesResponse | PlainMessage<GetOffboardingProfilesResponse> | undefined, b: GetOffboardingProfilesResponse | PlainMessage<GetOffboardingProfilesResponse> | undefined): boolean {
    return proto3.util.equals(GetOffboardingProfilesResponse, a, b);
  }
}

